import React, { useCallback } from "react";
import { usePermitApplicationContext } from "../../PermitApplicationContext";
import { DocumentUploadCardContent } from "./DocumentUploadCardContent";
import { useDocumentUpload } from "./useDocumentUpload";
import { DocumentUploadCardProps } from "./types";

export const DocumentUploadCard: React.FC<DocumentUploadCardProps> = ({
  documentTypeId,
  documentTypeName,
  documentTypeDescription,
  documentId,
  payeeAccountId,
}) => {
  const { updateDocument, clearDocument } = usePermitApplicationContext();

  const handleUploadComplete = useCallback(
    (newDocumentId: string) => {
      updateDocument(documentTypeId, newDocumentId);
    },
    [documentTypeId, updateDocument],
  );

  const handleClear = useCallback(() => {
    clearDocument(documentTypeId);
  }, [documentTypeId, clearDocument]);

  const { status, progress, uploadedFile, errorMessage, handleFileSelect, handleRemove, handleRetry } =
    useDocumentUpload({
      payeeAccountId,
      documentTypeId,
      onUploadComplete: handleUploadComplete,
      onClear: handleClear,
    });

  const effectiveStatus = documentId && status === "idle" ? "success" : status;

  return (
    <DocumentUploadCardContent
      documentTypeName={documentTypeName}
      documentTypeDescription={documentTypeDescription}
      status={effectiveStatus}
      progress={progress}
      uploadedFile={uploadedFile}
      errorMessage={errorMessage}
      onFileSelect={handleFileSelect}
      onRemove={handleRemove}
      onRetry={handleRetry}
    />
  );
};

export default DocumentUploadCard;
